import { Component, Input } from '@angular/core';
import {
    FrameworkColumn,
    ITableCellValueRenderer,
    SafeAny,
} from '@pf/shared-common';
import { uniqBy } from 'lodash-es';

export interface TagsRendererProps {
    tagsFn: (
        value: SafeAny,
        row: SafeAny
    ) => { color: string; label: string }[];
}

@Component({
    selector: 'pf-action-renderer',
    template: ` @for (item of list; track item.label) {
        <nz-tag [nzColor]="item.color">{{ item.label }}</nz-tag>
    }`,
    styles: [
        `
            :host {
                nz-tag {
                    margin: 2px;
                    border-radius: 15px;
                }
            }
        `,
    ],
    standalone: false,
})
export class TagsRendererComponent
    implements ITableCellValueRenderer, TagsRendererProps
{
    list: { color: string; label: string }[] = [];

    private _value: SafeAny;
    private _tagsFn?: (
        value: SafeAny,
        row: SafeAny
    ) => { color: string; label: string }[];
    private _row: SafeAny;

    // The table cell projects `value` before `tagsFn` (in one props object), so
    // a one-shot `value` setter renders blank until something re-projects (e.g.
    // clearing filters). Recompute on every input change so order doesn't matter.
    @Input() set tagsFn(
        fn: (value: SafeAny, row: SafeAny) => { color: string; label: string }[]
    ) {
        this._tagsFn = fn;
        this.render();
    }
    get tagsFn(): (
        value: SafeAny,
        row: SafeAny
    ) => { color: string; label: string }[] {
        return this._tagsFn as (
            value: SafeAny,
            row: SafeAny
        ) => { color: string; label: string }[];
    }

    @Input() set value(value: SafeAny) {
        this._value = value;
        this.render();
    }

    @Input() set row(row: SafeAny) {
        this._row = row;
        this.render();
    }
    get row(): SafeAny {
        return this._row;
    }

    @Input() column!: FrameworkColumn;

    private render(): void {
        this.list =
            this._value && this._tagsFn
                ? uniqBy(this._tagsFn(this._value, this._row), 'label')
                : [];
    }
}
